import OurVision from './OurVision'

export default OurVision
